import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PageService} from '../../services/page.service';
import Swal from 'sweetalert2';
import {error} from 'protractor';


@Component({
  selector: 'app-firma-expediente-modal',
  templateUrl: './firma-expediente-modal.component.html',
  styleUrls: ['./firma-expediente-modal.component.css']
})


export class FirmaExpedienteModalComponent implements OnInit {

  solicitud: any;
  docs  = {
    comprador: {
      poder: false,
      mandato: false,
      compraventa: false,
    },
    vendedor: {
      poder: false,
      mandato: false,
      compraventa: false,
    }
  };
  tipo = '';
  spinnerFirma = false;
  dataToShow = [true, true];
  constructor(public dialogRef: MatDialogRef<FirmaExpedienteModalComponent>,
              @Inject(MAT_DIALOG_DATA)public data: any,
              private pageService: PageService) { }

  ngOnInit(): void {
    console.log("OnInit");
    console.log(this.data);
    this.getDocsToSend();
  }

  
  getDocsToSend(): void{
    const colaborador = this.data.colaborador;
    this.tipo = this.data.tramite;
    if (this.tipo.startsWith('MATRICULACI')){
      this.dataToShow = [true, false];
    }else if (this.tipo.startsWith('CAMBIO DE') || this.tipo.startsWith('NOTIF')){
      this.dataToShow = [
        this.data.nombreCliente.replace(/\s/g, '') !== colaborador.replace(/\s/g, ''),
        this.data.nombreVendedor.replace(/\s/g, '') !== colaborador.replace(/\s/g, ''),

      ];
    }
    else{
      this.dataToShow = [true, true];
    }
  }

  autocheck(): void {

    if (this.data.nombrePoseedor.replace(/\s/g, '') !== this.data.nombreCliente.replace(/\s/g, '') &&
      this.data.nombrePoseedor.replace(/\s/g, '') !== this.data.nombreVendedor.replace(/\s/g, '') &&
      (this.data.nombrePoseedor !== '' || this.data.nombrePoseedor !== ' ')){
      this.docs.vendedor.compraventa = this.docs.comprador.compraventa;
    }
  }
  submit(): void{
    console.log(this.docs);
    if (this.data.nombrePoseedor.replace(/\s/g, '') === this.data.colaborador.replace(/\s/g, '')){
      this.dobleRequest();
    }else{
      this.singleRequest();
    }
  }

  dobleRequest(): void{
    const data1 = {
      numExpediente: this.data.numeroExpediente,
      docs: {
        vendedor: this.docs.comprador,
        comprador: false
      }
    };

    const data2 = {
      numExpediente: this.data.numeroExpediente,
      docs: {
        comprador: this.docs.vendedor,
        vendedor: false
      }
    };
    this.spinnerFirma = true;
    this.pageService.postViafirma(data1).subscribe({
      next: value => {
        this.pageService.postViafirma(data2).subscribe({
          next: val => {
            this.shootSwal('Firmas enviadas con éxito', 'success');
            this.dialogRef.close();
              },
          error: err => {
            this.shootSwal('Error en el envio de firmas: ' + err.error, 'warning');
            this.dialogRef.close();
            },
          complete: () => {
            this.spinnerFirma = false;
          }
        });
      },
      error: err => {
        console.log(err);
        this.spinnerFirma = false;
        this.shootSwal('Error en el envio de firmas: ' + err.error.message, 'warning');
      },
      complete: () => {}
    });
  }

  singleRequest(): void {
    const data = {
      numExpediente: this.data.numeroExpediente,
      docs: this.docs,
    };
    this.spinnerFirma = true;
    this.pageService.postViafirma(data).subscribe({
      next: value => {
        this.shootSwal('Firmas enviadas con éxito', 'success');
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.shootSwal('Error en el envio de firmas: ' + err.error.message, 'warning');
      },
      complete: () => {
        this.spinnerFirma = false;
      }
    });
  }

  checkDisabled(): boolean {
    return this.data.colaborador.replace(/\s/g, '') !== this.data.nombreCliente.replace(/\s/g, '') &&
      this.data.colaborador.replace(/\s/g, '') !== this.data.nombreVendedor.replace(/\s/g, '') &&
      (this.data.nombrePoseedor === '' || this.data.nombrePoseedor === ' ');
  }
  shootSwal(message: string,  type): void {
    Swal.fire('', message, type);
  }
}
